export default __webpack_public_path__ + "static/media/phone.922ced07.svg";